import React from "react";
import { useState } from "react";
import { Grid, Tab } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { HeaderLabel } from "../../../constants/Authorization";
import fontWeight from "../../../styles/mui/fontWeight";
import {
  displayFlex,
  flexAlignCentre,
} from "../../../styles/mui/styles/display";
import {
  FaChevronCircleDownIcon,
  FaChevronCircleUpIcon,
  GeneralInfoItemsTabs,
  GeneralInfoTabBorderBottom,
  HeaderTabs,
  MainGrid,
  MinimizeMaximizeIcon,
  TablePanelGrid,
} from "../styles/AuthorizationDetailsTabs";
import { a11yProps } from "../../../utils";
import GeneralInfo from "../containers/GeneralInfo";
import RequestDetails from "../containers/RequestDetails";
import Notes from "../containers/Notes";
import DocumentList from "../containers/DocumentList";
import LetterDecisionNotification from "../containers/LetterDecisionNotification";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}
const AuthorizationDetailsTabs: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [minimizeTab, setMinimizeTab] = useState(false);

  const handleChange = async (
    _event: React.SyntheticEvent,
    newValue: number
  ) => {
    setActiveTab(newValue);
    setMinimizeTab(false);
  };

  return (
    <Box>
      <Grid container sx={MainGrid}>
        <Grid size={11}>
          <Box sx={displayFlex}>
            <Box sx={MinimizeMaximizeIcon}>
              {minimizeTab ? (
                <FaChevronCircleDownIcon
                  onClick={() => setMinimizeTab(false)}
                  data-testid="general-info-tabs-hide"
                />
              ) : (
                <FaChevronCircleUpIcon
                  onClick={() => setMinimizeTab(true)}
                  data-testid="general-info-tabs-show"
                />
              )}
            </Box>
            <Box sx={flexAlignCentre}>
              <GeneralInfoItemsTabs
                value={activeTab}
                onChange={handleChange}
                aria-label="Authorization details screen tabs"
              >
                {HeaderLabel.map((tablecell, index) => (
                  <Tab
                    sx={HeaderTabs}
                    key={tablecell.label}
                    label={
                      <Typography
                        variant="subtitle1"
                        fontWeight={fontWeight.Weight[5]}
                      >
                        {tablecell.label}
                      </Typography>
                    }
                    {...a11yProps(index)}
                  />
                ))}
              </GeneralInfoItemsTabs>
            </Box>
          </Box>
        </Grid>
        <Grid size={12} sx={TablePanelGrid}>
          <GeneralInfoTabBorderBottom />
        </Grid>
        <Grid size={12}>
          {!minimizeTab && (
            <>
              <TabPanel value={activeTab} index={0}>
                <GeneralInfo />
              </TabPanel>
              <TabPanel value={activeTab} index={1}>
                <RequestDetails />
              </TabPanel>
              <TabPanel value={activeTab} index={2}>
                <DocumentList />
              </TabPanel>
              <TabPanel value={activeTab} index={3}>
                <Notes />
              </TabPanel>
              <TabPanel value={activeTab} index={4}>
                <LetterDecisionNotification />
              </TabPanel>
            </>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default AuthorizationDetailsTabs;
